import { host } from '@branding/config';
import { QuestionResponse } from '@/types/QuestionTypes';
import { useAnalytics } from '@hooks/useAnalytics';
import { fetchWithRetry } from '@/network';
import { usePostHog } from 'posthog-js/react';

interface Params {
	requestBody: any;
}

export const useQueryCompleteInvestigation = () => {
	const { trackRefineEvent } = useAnalytics();
	const posthog = usePostHog();
	const sessionID = posthog?.get_session_id();

	const postCompleteInvestigation = async ({ requestBody }: Params): Promise<QuestionResponse | null> => {
		const url = new URL(`${host}/api/branchCompleteInvestigation`);

		const response = await fetchWithRetry<QuestionResponse>(
			url.toString(),
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Refine-Sessionid': sessionID,
				},
				body: JSON.stringify(requestBody),
			},
			{
				endpoint: 'branchCompleteInvestigation',
				analytics: { trackRefineEvent },
			},
		);

		if (response) {
			sessionStorage.removeItem('investigationContextOpened');
			sessionStorage.removeItem('sessionMetrics');
			sessionStorage.removeItem('currentQuestionId');
		}

		return response;
	};

	return { postCompleteInvestigation };
};
